/* unplugin-vue-components disabled */import { render } from "./CustomerBasket.vue?vue&type=template&id=1f077ab3&ts=true"
import script from "./CustomerBasket.vue?vue&type=script&lang=ts"
export * from "./CustomerBasket.vue?vue&type=script&lang=ts"

import "./CustomerBasket.vue?vue&type=style&index=0&id=1f077ab3&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__